import React, {useEffect, useState} from 'react';
import Swiper from 'react-id-swiper';
import InstructionSlide from "./InstructionSlide";
import OnboardingScreen from "../OnboardingScreen";
import {IOnboardingStore} from "../../stores/OnboardingStore";
import {IImage} from "../../stores/models";
import LandingPageScreen, {ItemWithAvatar} from "../LandingPageScreen";
import {ILandingPageStore} from "../../stores/LandingPageStore";
import classNames from "classnames";

interface Props {
    onClose?: () => void
    firstScreen: IOnboardingStore,
    secondScreen: IOnboardingStore,
    groupAvatar: IImage | null,
    previewHint?: string,
    landingPage: ILandingPageStore;
    user?: ItemWithAvatar,
    group: ItemWithAvatar
}

const slideChangeTransitionStart = () => {
    const swiperEl = document.querySelector('.swiper-container-preview-screen');
    if (!swiperEl) return;
    // @ts-ignore
    const swiper = swiperEl.swiper;
    if (!swiper) return;
    let $wrapperEl = swiper.$wrapperEl;
    let params = swiper.params;
    $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
        .each(function () {
            // @ts-ignore
            let idx = this.getAttribute('data-swiper-slide-index');
            // @ts-ignore
            this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
        });
};

const slideChangeTransitionEnd = () => {
    const swiperEl = document.querySelector('.swiper-container-preview-screen');
    if (!swiperEl) return;
    // @ts-ignore
    const swiper = swiperEl.swiper;
    if (!swiper) return;
    swiper.slideToLoop(swiper.realIndex, 0, false);
};

const params = {
    loop: true,
    neste: true,
    on: {
        // See https://github.com/nolimits4web/swiper/issues/2629
        slideChangeTransitionStart,
        slideChangeTransitionEnd,
    }
};

const MainSwiper = (props: Props) => {

    // Props

    const {onClose, previewHint, groupAvatar, landingPage, firstScreen, user, group, secondScreen} = props;

    // State

    const [isEditing, setIsEditing] = useState(false);
    const [hasSecondScreen, setHasSecondScreen] = useState(secondScreen.hasScreen);

    useEffect(() => {
        setHasSecondScreen(secondScreen.hasScreen);
        // eslint-disable-next-line
    }, []);

    return <Swiper  {...params} shouldSwiperUpdate
                    containerClass={"swiper-container-preview-screen"}>
        <div>
            <InstructionSlide
                previewHint={previewHint}
                onClose={onClose}/>
        </div>

        <div className={classNames({
            'swiper-no-swiping': isEditing,
        })}>
            <OnboardingScreen
                title={"preview_screen_header_title_while_previewing"}
                subtitle={"preview_screen_header_subtitle_while_previewing"}
                number={1}
                isPreviewSlider
                isSharedPreview={!onClose}
                setIsEditing={setIsEditing}
                groupAvatar={groupAvatar}
                store={firstScreen}
            />
        </div>

        {!hasSecondScreen ? <></> :
            <div className={classNames({
                'swiper-no-swiping': isEditing,
            })}>
                <OnboardingScreen
                    title={"preview_screen_header_title_while_previewing"}
                    subtitle={"preview_screen_header_subtitle_while_previewing"}
                    number={2}
                    isSharedPreview={!onClose}
                    isPreviewSlider
                    setIsEditing={setIsEditing}
                    groupAvatar={groupAvatar}
                    store={secondScreen}
                />
            </div>
        }

        <div className={classNames({
            'swiper-no-swiping': isEditing,
        })}>
            <LandingPageScreen
                isPreviewSlider
                title={"preview_screen_header_title_while_previewing"}
                subtitle={"preview_screen_header_subtitle_while_previewing"}
                store={landingPage}
                isSharedPreview={!onClose}
                setIsEditing={setIsEditing}
                user={user}
                group={group}
            />
        </div>

    </Swiper>
};

export default MainSwiper;
